module.exports = __webpack_public_path__ + "img/homepage-aircon.4d53c51e.jpg";